import queryParam from "../helper/queryParamValue";

const state = {
	applicantsArchivalStatus: 'AVAILABLE',
	currentJobDetails: [],
	jobs: [],
	status: 'PENDING',
	error: '',
	jobSearchField: '',
	locationSearchField: '',
	specializationField: [],
	tagField: [],
	checkBoxFilters: [
		{
			group: { name: 'Job status', slug: 'status' },
			lists: [
					{
						name: 'All jobs', slug: 'all'
					},
					{
						name: 'Active jobs', slug: 'ACTIVE'
					},
					{
						name: 'Archived jobs', slug: 'DELETED'
					},
					{
						name: 'Suspended jobs', slug: 'SUSPENDED'
					},
					{
						name: 'Draft jobs', slug: 'DRAFT'
					},
					{
						name: 'Private jobs', slug: 'PRIVATE'
					},
					{
						name: 'Expired jobs', slug: 'EXPIRED'
					}
				],
			showCount: true,
			show: true,
			choice: 'single'
		},
		{
			group: { name: 'Work style', slug: 'work_style' },
			lists: [
					{
						name:'Remote', slug:'remote'
					},
					{
						name:'Hybrid', slug:'hybrid'
					},
					{
						name:'Onsite', slug:'onsite'
					}
			],
			showCount: false,
			show: true,
			choice: 'multiple'
		},
		{
			group: { name: 'Employment type', slug: 'type' },
			lists: [
					{
						name:'Full-time', slug:'full-time'
					},
					{
						name:'Part-time', slug:'part-time'
					},
					{
						name:'Contract', slug:'contract'
					},
					{
						name:'Intership', slug:'internship'
					}
			],
			showCount: false,
			show: true,
			choice: 'multiple'
		},
	],
	filtersApplied: [{ group: 'status', listName: 'All jobs', listSlug: 'all' }],
	jobsMeta: {},
	page: 1,
}

const getters = {
 	getJobs: state => state.jobs,
  	getFiltersApplied: state => state.filtersApplied,
  	getCheckBoxFilters: state => state.checkBoxFilters,
  	getStatus: state => state.status,
  	getJobsMeta: state => state.jobsMeta,
  	getTagField: state => state.tagField,
  	getSpecializationField: state => state.specializationField,
  	getQueryParams: state => {
		const params = {};
		if(state.page) params['page'] = state.page
        state.filtersApplied.forEach((data, index) => {
        	if(
        		data.group === 'search' ||
        		data.group === 'location' ||
        		data.group === 'specializations' ||
        		data.group === 'tags' ||
        		data.group === 'status'
        	){
        		params[data.group] = data.listSlug
        		return
        	}
        	if (!params[data.group]) params[data.group] = []
        	params[data.group].push(data.listSlug)
        })
        return params
  	},
  	isActive: state  => list => {
  	  	return !!state.filtersApplied.find(obj => obj.listSlug === list)
  	}
}

const mutations = {
	SET_ARCHIVAL_STATUS(state, payload){
		state.applicantsArchivalStatus = payload
	},
	REQUEST_JOBS_PENDING(state){
		state.status = 'PENDING'
	},
	REQUEST_JOBS_SUCCESS(state, payload){
		
		const { data, ...meta } = payload
		state.status = 'SUCCESS'
		state.jobs = data
		state.jobsMeta = {
			...meta,
			next_page: queryParam(meta.next_page_url, "page")
		} 
	},
	REQUEST_JOBS_FAILED(state, data){
		state.status = 'ERROR', state.error = data
	},
	SET_SEARCH_FIELD(state, data){
		state.jobSearchField = data
	},
	SET_SELECTED_VIEWED_JOB(state, data){
		state.currentJobDetails = data;
	},
	SET_LOCATION_FIELD(state, data){
		state.locationSearchField = data
	},
	SET_SPECIALIZATION_FIELD(state, data){
		state.specializationField = data
	},
	SET_TAG_FIELD(state, data){
		state.tagField = data
	},
	SET_CHECKBOX_FILTERS(state, data){
		state.checkBoxFilters = data
	},
	REMOVE_FILTER_APPLIED(state, index){
		state.filtersApplied.splice(index, 1)
	},
	ADD_FILTER_APPLIED(state, data){		
		state.filtersApplied.push(data)
	},
	CLEAR_FILTERS_APPLIED(state){
		state.filtersApplied = [{ group: 'status', listName: 'All jobs', listSlug: 'all' }]
	},
	SET_PAGE(state, page){
		state.page = page
	},
}

const actions = {
	requestJobs ({ commit, getters }, limit) {
		let params = getters.getQueryParams

		if (limit) {
			params = { ...params, limit }
		}
		commit('REQUEST_JOBS_PENDING')
	
		axios.get('/v2/admin/jobs/list', { params })
		    .then(res => {
		    	commit('REQUEST_JOBS_SUCCESS', res.data.data)
		    })
		    .catch(err => {
		    	commit('REQUEST_JOBS_FAILED', err)
		    })
	},
	setJobSearchField ({ state, commit, dispatch }, text) {
		const index = state.filtersApplied.findIndex(obj => obj.group === 'search')
  		const data = { group:'search', listName: 'Search', listSlug: text }
	    commit('SET_SEARCH_FIELD', text)
	    if(index > -1 || text == '') commit('REMOVE_FILTER_APPLIED', index)
	  	if(text !== '') commit('ADD_FILTER_APPLIED', data)
	  	commit('SET_PAGE', 1)
	  	dispatch('requestJobs')
	},
	setJobLocationField ({ state, commit, dispatch }, text) {		
		const index = state.filtersApplied.findIndex(obj => obj.group === 'location')
		const data = { group:'location', listName: 'Location', listSlug: text }
	    commit('SET_LOCATION_FIELD', text)
	    if(index > -1 || text == '') commit('REMOVE_FILTER_APPLIED', index)
	  	if(text !== '') commit('ADD_FILTER_APPLIED', data)
	  	commit('SET_PAGE', 1)
	  	dispatch('requestJobs')
	},
	setSpecializationField ({ state, commit, dispatch }, array) {
		const index = state.filtersApplied.findIndex(obj => obj.group === 'specializations')
		const data = { group:'specializations', listName: 'Specializations', listSlug: array }
	    commit('SET_SPECIALIZATION_FIELD', array)
	    if(index > -1) commit('REMOVE_FILTER_APPLIED', index)
	  	if(array.length > 0) commit('ADD_FILTER_APPLIED', data)
	  	commit('SET_PAGE', 1)
	  	dispatch('requestJobs')
	},
	setTagField ({ state, commit, dispatch }, array) {
		const index = state.filtersApplied.findIndex(obj => obj.group === 'tags')
		const data = { group:'tags', listName: 'Tags', listSlug: array }
	    commit('SET_TAG_FIELD', array)
	    if(index > -1) commit('REMOVE_FILTER_APPLIED', index)
	  	if(array.length > 0) commit('ADD_FILTER_APPLIED', data)
	  	commit('SET_PAGE', 1)
	  	dispatch('requestJobs')
	},
	setFilterGroup({ state, commit }, {filterIndex, value}){
		const checkBoxFilters = state.checkBoxFilters.map((item, index) => {
			if(index == filterIndex) item.show = value
					return item
				})
		commit('SET_CHECKBOX_FILTERS', checkBoxFilters)
	},
	setFilterList({ state, dispatch, commit }, { filter, list }){
		const data = { group: filter.group.slug, listName: list.name, listSlug: list.slug }
		const groupIndex = state.filtersApplied.findIndex(obj => obj.group === 'status')
		const index = state.filtersApplied.findIndex(obj => obj.listSlug === list.slug)
		
		if (filter.group.slug === 'status'){
			commit('REMOVE_FILTER_APPLIED', groupIndex)
			commit('ADD_FILTER_APPLIED', data)
		}else{
			index > -1 ? commit('REMOVE_FILTER_APPLIED', index) : commit('ADD_FILTER_APPLIED', data)
			commit('SET_PAGE', 1)
		}
		commit('SET_PAGE', 1)
		dispatch('requestJobs')
	},
	clearFiltersApplied({ commit, dispatch }) {
		commit('CLEAR_FILTERS_APPLIED')
		commit('SET_PAGE', 1)
		dispatch('requestJobs')
	},
	setPage({ commit, dispatch }, page){		
		commit('SET_PAGE', page)
		dispatch('requestJobs')
	}
}

const JobStore = {
	state,
	mutations,
	actions,
	getters
}

export default JobStore
